import { Box, Button, Grid, Icon, Paper, Typography } from "@mui/material";
import * as React from "react";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useClass } from "../../globals/ClassContext";
import AssignmentsOverview from "./AssignmentsOverview";
import AssignmentSubmissions from "./AssignmentSubmissions";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GenericModal from "../Modals/GenericModal/GenericModal";

export default function AdminOverview(props) {
  const { setPage } = props;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const openModal = () => {
    handleOpen()
  }
  
  return (
      <div>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            fontSize={24}
            align="center"
            //sx={{ pb: "15px" }}
          >
            <Typography>Open Assignments</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <AssignmentsOverview openModal={openModal} filter="open"/>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
            fontSize={24}
            align="center"
            //sx={{ pb: "15px" }}
          >
            <Typography>Closed Assignments</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <AssignmentsOverview openModal={openModal} filter="closed"/>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            fontSize={24}
            align="center"
            //sx={{ pb: "15px" }}
          >
            <Typography>Unopened Assignments</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <AssignmentsOverview openModal={openModal} filter="unopened"/>
          </AccordionDetails>
        </Accordion>
        <GenericModal open={open} handleClose={handleClose} body={<AssignmentSubmissions setPage={setPage}/>}/>
      </div>
      
  )
}
